import type {
  InvalidSgmOpportunity,
  MultipleAvailableOpportunity,
  MultipleOpportunity,
  SgmOpportunity,
  SingleAvailableOpportunity,
  SingleOpportunity,
  SingleUnavailableOpportunity
} from '@swf/generated/types/api/sports';

type Opportunity = SingleOpportunity | MultipleOpportunity;

export const isSingleOpportunity = (opportunity: Opportunity): opportunity is SingleOpportunity =>
  opportunity.type === 'SINGLE';

export const isAvailableOpportunity = (
  opportunity: Opportunity
): opportunity is SingleAvailableOpportunity | MultipleAvailableOpportunity =>
  opportunity.status === 'AVAILABLE';

export const isSingleAvailableOpportunity = (
  opportunity: Opportunity
): opportunity is SingleAvailableOpportunity =>
  isSingleOpportunity(opportunity) && isAvailableOpportunity(opportunity);

export const isSuspendedOpportunity = (
  opportunity: Opportunity
): opportunity is SingleUnavailableOpportunity =>
  isSingleOpportunity(opportunity) && opportunity.status === 'SUSPENDED';

export const isUnavailableOpportunity = (
  opportunity: Opportunity
): opportunity is SingleUnavailableOpportunity | InvalidSgmOpportunity =>
  opportunity.status === 'UNAVAILABLE';

export const isUnavailableSingleOpportunity = (
  opportunity: Opportunity
): opportunity is SingleUnavailableOpportunity =>
  isSingleOpportunity(opportunity) && isUnavailableOpportunity(opportunity);

export const isMultipleOpportunity = (
  opportunity: Opportunity
): opportunity is MultipleOpportunity => opportunity.type !== 'SINGLE';

export const isInvalidSgmOpportunity = (
  opportunity: Opportunity
): opportunity is InvalidSgmOpportunity =>
  isUnavailableOpportunity(opportunity) && isMultipleOpportunity(opportunity);

export const isSgmOpportunity = (
  opportunity: Opportunity
): opportunity is SgmOpportunity | InvalidSgmOpportunity =>
  (isMultipleOpportunity(opportunity) && opportunity.isSgm) || isInvalidSgmOpportunity(opportunity);
